import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 操作公告栏列表
export const operBulletin = data => {
  return axios.request({
    url: `/common/notice${data.id ? "/" + data.id : ""}`,
    data,
    method: data.method ? data.method : "get"
  });
};

// 添加公告栏
export const addBulletin = data => {
  return axios.request({
    url: `/common/notice`,
    data,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

// 公告栏推送
export const pushBulletin = params => {
  return axios.request({
    url: `/common/notice/elastic`,
    params,
    method: "get"
  });
};

// 公告栏已读
export const readBulletin = id => {
  return axios.request({
    url: `/common/notice/browse/` + id,
    method: "get"
  });
};

// 获取通知查看详情
export const getBulletinDetail = params => {
  return axios.request({
    url: `/common/notice/readlog/` + params.id,
    method: "get",
    params
  });
};
